import { finish, error } from '../../../modules/customers/actions/open';
import { bulk } from '../../../modules/customers/actions/update-data';
import { finish as getReferredBetslip } from '../../../modules/betslip/actions/get-referred-betslip';
import { request as getReferredBetslip } from '../../../modules/betslip/actions/get-referred-betslip';
import { clear as clearReferredBetslip } from '../../../modules/betslip/actions/get-referred-betslip';
import { clear as clearOfferReferredBetslip }from '../../../modules/betslip/actions/offer-referred-betslip';
import socketPromise from '../../../websocket';

import api from '../../../api';

export function request(dispatch, { id }) {
    api.get('/customers/' + id, void 0, { cache: true }).then(
        (customer) => {
            socketPromise.then(socket => {
                socket.subscribe(id + ':Wallet', ({ body }) => {
                    dispatch(bulk([
                        {
                            id,
                            wallet: body
                        }
                    ]));
                });
                socket.subscribe(id + ':RefBet', ({ header, body }) => {
                    let bets = body.referredBetslip.bets;

                    bets.forEach((bet, i) => {
                        bet.legs.forEach(leg => {
                            if (leg.type === 'betBuilder') {
                                leg.eventId = leg.internalEventId;
                            } else if (leg.type !== 'empty') {
                                leg.eventId = parseInt(leg.event.id, 10);
                                leg.marketId = parseInt(leg.market.id, 10);
                                leg.selectionId = parseInt(leg.selection.id, 10);
                            } else {
                                leg.market = null;
                                leg.eventName = leg.event.name;
                                leg.selectionName = leg.selection.name;
                            }

                            delete leg.event;
                            delete leg.market;
                            delete leg.selection;
                        });
                    });
                    dispatch(getReferredBetslip(id));

                    if (header.type === 'request') {
                        dispatch(clearOfferReferredBetslip());
                    }

                    if (header.type === 'accept' || header.type === 'reject') {
                        setTimeout(() => {
                            dispatch(clearReferredBetslip(id));
                        }, 4000);
                    }
                });
            });

            dispatch(finish(customer));
        },
        ({ errors }) => dispatch(error(id, errors))
    );
}
